import { api } from './BaseApi'
import {
  ISendTagsToFotoboxesRequest,
  ITag,
  ITagsRequestDto,
  ITagsResponseDto,
} from './dto/TagsDto'

export const tagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTagsList: builder.query<ITagsResponseDto, ITagsRequestDto>({
      query: (params) => ({
        url: '/tags/',
        params: !!params ? params : {},
      }),
      providesTags: ['Tags'],
    }),
    getTagDetail: builder.query<ITag, number>({
      query: (id) => ({
        url: `/tags/${id}/`,
      }),
      providesTags: ['Tags'],
    }),
    createTag: builder.mutation<ITag, Partial<ITag>>({
      query: (body) => ({
        url: '/tags/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Tags'],
    }),
    updateTag: builder.mutation<ITag, Partial<ITag>>({
      query: (body) => ({
        url: `/tags/${body.id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Tags'],
    }),
    archiveMultipleTag: builder.mutation<ITag, { ids: number[] }>({
      query: ({ ids }) => ({
        url: `/tags/delete_multiple_tags/`,
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: ['Tags'],
    }),
    sendTagsToFotoboxes: builder.mutation<void, ISendTagsToFotoboxesRequest>({
      query: (body) => ({
        method: 'POST',
        url: '/tags/send_tags_to_fotoboxes/',
        body,
      }),
      invalidatesTags: ['Tags'],
    }),
    deleteTagsToFotoboxes: builder.mutation<void, ISendTagsToFotoboxesRequest>({
      query: (body) => ({
        method: 'PATCH',
        url: '/tags/remove_tags_from_fotoboxes/',
        body,
      }),
      invalidatesTags: ['Tags'],
    }),
    deleteTags: builder.mutation<void, number>({
      query: (id) => ({
        url: `/tags/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tags'],
    }),
  }),
})

export const {
  useGetTagsListQuery,
  useGetTagDetailQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useArchiveMultipleTagMutation,
  useSendTagsToFotoboxesMutation,
  useDeleteTagsToFotoboxesMutation,
} = tagsApi
